module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_8.c956bdf3.png";